import moment from 'moment'

export default {
  data () {
    return {
      year: moment().format('YYYY')
    }
  }
}